import { useTranslation } from "react-i18next"

import { LanguageSelect } from "@/features/base-settings/components/language-select"

import { useChooseTranslateLanguage } from "../hooks/use-choose-translate-language"

export function ChooseTranslateLanguageSelect() {
  const { t } = useTranslation()

  const {
    handleChangeLanguage,
    handleAddLanguage,
    selectedLanguage,
    availableLanguages,
    handleDeleteLanguage,
  } = useChooseTranslateLanguage()

  return (
    <LanguageSelect
      availableLanguages={availableLanguages}
      label={t("pages.translate.translate_to")}
      selectedLanguage={selectedLanguage}
      onAddLanguage={handleAddLanguage}
      onChangeLanguage={handleChangeLanguage}
      onDeleteLanguage={handleDeleteLanguage}
    />
  )
}
